import { useMemo } from 'react';

export const useIsPuzzleWalletWebView = () => {
  const isPuzzleWalletWebview = useMemo(() => {
    const userAgent = window.navigator.userAgent;

    if (userAgent.includes('PuzzleWallet')) {
      return true;
    }
    return false;
  }, [window.navigator.userAgent]);

  return isPuzzleWalletWebview;
};
